import React, { FC } from 'react';
import styles from './coloredCircle.module.scss';

const ColoredCircle: FC<{ color: string }> = ({ color }) => {
  return <span className={styles.circle} style={{ background: color }} />;
};

export default ColoredCircle;
